export default __webpack_public_path__ + "static/media/Cleaned-Up-Adhesive-01.e44e33b1.jpg";